/**
 * OVERRIDE Footer.jsx
 */

import Footer from '../../../../components/Footer/Footer';

export default Footer;